
import {getProductByID, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function RomanBlindsPage() {

  return (
      GenericProductPage(getProductByID(41),toBlind)
  )
}
